import React , {useEffect, useState} from 'react';
import { useDispatch , useSelector } from 'react-redux';
import { getVechicles } from '../components/edit-vechicle-component/edit-vechicle.module';
import { getBusDetailsAction } from '../actions/trip-create.actions';
import { tripCreateReducerSelector } from '../selector/trip-create.selector';
import '../styles/vehicle-management.style.scss';
import { VechicleManagementForm } from '../components/vechicle-management-component/vechicle-management-form.component';
import { VechicleManagementTable } from '../components/vechicle-management-component/vechicle-management-table.component';

export const VehicleManagementPage = (props) => {

    const dispatch = useDispatch();
    const tripCreateReducer = useSelector(tripCreateReducerSelector);
    let { busesData } = tripCreateReducer;
    const [formData,updateFormData] = useState({});
    const [vehicles,setVehicles]=useState([]);

    const fetchVechicles=()=>{
        getVechicles((vehicleData) => {
            setVehicles(vehicleData);
        });
    }

    useEffect(()=>{
        fetchVechicles();
        dispatch(getBusDetailsAction());
    },[]);

    return (
        <div className="vehicle-management-root">
            <VechicleManagementTable 
                vehicles={vehicles}
                busesData={busesData}
                formData={formData}
                updateFormData={updateFormData}
            />
            <VechicleManagementForm
                formData={formData}
                updateFormData={updateFormData}
                fetchVechicles={fetchVechicles}
                busesData={busesData}
                vehicles={vehicles}
            />
        </div>
    );
}